import { paginate } from '../utils/index.js'
import { Response } from 'miragejs'

export function engagementRoutes () {
  const restPrefix = process.env.MOCK_REST_URL_SUFIX
  this.urlPrefix = process.env.MOCK_BASE_APIS_URL

  this.get(`${restPrefix}/engagement/campaigns`, (schema, request) => {
    const route_path = `${this.urlPrefix}/engagement/campaigns`
    const { queryParams: { page = 1, limit = 5, title } } = request

    let campaigns = schema.db.campaigns
    campaigns = title ? searchObjectsByAttribute(campaigns, 'title', title) : campaigns || []

    const { paginatedItems, meta } = paginate(
      campaigns,
      Number(page),
      Number(limit)
    )

    return {
      data: paginatedItems,
      links: {
        first: `${route_path}?page=1`,
        last: `${route_path}?page=${last_page}`,
        prev: null,
        next: null
      },
      meta
    }
  })
  this.get(`${restPrefix}/engagement/coin`, (schema, request) => {
    const coin = schema.db.coins
    return new Response(200, {}, {
      data: {
        ...coin[0]
      }

    })
  })
}



// WEBPACK FOOTER //
// ./src/mocks/routes/engagement.js